import { LANGUAGE } from "@monorepo/constants";
import { LanguagesEnum } from "@monorepo/types";
import { format as formatFn, Locale } from "date-fns";
import ltLocale from "date-fns/locale/lt";
import plLocale from "date-fns/locale/pl";

export const getLocale = () => {
  switch (LANGUAGE) {
    case LanguagesEnum.PL:
      return plLocale;
    default:
      return ltLocale;
  }
};

export const formatDateWithLocale = (
  date: Date | number,
  format: string,
  options?: {
    locale?: Locale;
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    firstWeekContainsDate?: number;
    useAdditionalWeekYearTokens?: boolean;
    useAdditionalDayOfYearTokens?: boolean;
  }
) => {
  return formatFn(date, format, { ...options, locale: options?.locale || getLocale() });
};
